import { Compass } from "lucide-react";
import { useLiveWind } from "@/hooks/useLiveWind";

const NORTH_GROUP = ["Maestrale", "Tramontana", "Grecale"];
const SOUTH_GROUP = ["Scirocco", "Mezzogiorno", "Libeccio"];

function suggestionFor(name) {
  if (NORTH_GROUP.includes(name)) return "Meglio le spiagge del versante SUD";
  if (SOUTH_GROUP.includes(name)) return "Meglio le spiagge del versante NORD";
  return null;
}

export default function LiveWindBadge({ className = "" }) {
  const { wind, error } = useLiveWind();

  if (error) return null;

  if (!wind) {
    return (
      <div className={`inline-flex items-center gap-2 text-sm text-[#8A9BA8] ${className}`}>
        <div className="w-4 h-4 rounded-full border-2 border-[#D96C4A]/30 border-t-[#D96C4A] animate-spin" />
        Vento in tempo reale…
      </div>
    );
  }

  const suggestion = suggestionFor(wind.name);

  return (
    <div
      data-testid="live-wind-badge"
      className={`inline-flex items-center gap-3 px-4 py-2.5 rounded-2xl bg-white border border-[#1D3A4C]/10 ${className}`}
    >
      <Compass
        className="w-6 h-6 text-[#D96C4A] shrink-0"
        strokeWidth={1.5}
        style={{ transform: `rotate(${wind.deg}deg)` }}
      />
      <div className="leading-tight">
        <div className="text-sm text-[#1D3A4C]">
          Vento ora: <span className="font-semibold">{wind.name}</span>{" "}
          <span className="text-[#8A9BA8]">· {wind.speed} km/h</span>
        </div>
        {suggestion && (
          <div className="text-xs text-[#D96C4A] font-medium mt-0.5">
            {suggestion}
          </div>
        )}
      </div>
    </div>
  );
}
